import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface QueueEntry {
  token: number;
  status: string;
  wait_minutes: number;
}

export default function WaitingRoom() {
  const [queue, setQueue] = useState<QueueEntry[]>([]);
  const [clinicName] = useState('Thaila Dental');
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const fetchQueue = () => {
      axios.get('/api/public/queue')
        .then((r) => setQueue(r.data?.queue || []))
        .catch(() => {});
    };
    fetchQueue();
    const interval = setInterval(fetchQueue, 30000); // Refresh every 30s
    const clockInterval = setInterval(() => setNow(new Date()), 1000);
    return () => { clearInterval(interval); clearInterval(clockInterval); };
  }, []);

  const currentlyServing = queue.find((q) => q.status === 'IN_PROGRESS');
  const waiting = queue.filter((q) => q.status === 'WAITING');

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px',
      color: '#fff', fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, margin: '0 0 8px', letterSpacing: -1,
          background: 'linear-gradient(135deg, #8b5cf6, #06b6d4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>{clinicName}</h1>
        <div style={{ fontSize: 20, color: '#94a3b8', fontWeight: 300 }}>
          {now.toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
        <div style={{ fontSize: 48, fontWeight: 200, color: '#e2e8f0', marginTop: 8 }}>
          {now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
        </div>
      </div>

      {/* Currently Serving */}
      {currentlyServing && (
        <div style={{
          background: 'linear-gradient(135deg, rgba(139,92,246,0.2), rgba(59,130,246,0.2))',
          borderRadius: 20, padding: '24px 48px', marginBottom: 32, textAlign: 'center',
          border: '1px solid rgba(139,92,246,0.3)', backdropFilter: 'blur(10px)',
          animation: 'pulse 2s infinite',
        }}>
          <div style={{ fontSize: 14, color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 2 }}>Now Serving</div>
          <div style={{ fontSize: 64, fontWeight: 800, color: '#8b5cf6', margin: '4px 0' }}>#{currentlyServing.token}</div>
        </div>
      )}

      {/* Queue */}
      <div style={{ width: '100%', maxWidth: 600 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, color: '#94a3b8', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 1 }}>
          Waiting ({waiting.length})
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {waiting.map((q, i) => (
            <div key={q.token} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: '14px 20px',
              border: '1px solid rgba(255,255,255,0.08)', backdropFilter: 'blur(5px)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 24, fontWeight: 700, color: '#e2e8f0', minWidth: 50 }}>#{q.token}</span>
                <span style={{ fontSize: 13, color: '#64748b' }}>Position {i + 1}</span>
              </div>
              <span style={{
                fontSize: 12, padding: '4px 12px', borderRadius: 20,
                background: 'rgba(245,158,11,0.15)', color: '#f59e0b',
                border: '1px solid rgba(245,158,11,0.2)',
              }}>~{q.wait_minutes} min</span>
            </div>
          ))}
          {waiting.length === 0 && (
            <div style={{ textAlign: 'center', padding: 40, color: '#475569', fontSize: 14 }}>
              No patients waiting 🎉
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.85; }
        }
      `}</style>
    </div>
  );
}
